/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarObject } from '../../models/calendar-object';

export interface ApiCtCoolingSystemGetCalendarLogCountGet$Params {
  serialNumber: string;
  materialNumber: number;
}

export function apiCtCoolingSystemGetCalendarLogCountGet(http: HttpClient, rootUrl: string, params: ApiCtCoolingSystemGetCalendarLogCountGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalendarObject>>> {
  const rb = new RequestBuilder(rootUrl, apiCtCoolingSystemGetCalendarLogCountGet.PATH, 'get');
  if (params) {
    rb.query('serialNumber', params.serialNumber, {});
    rb.query('materialNumber', params.materialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CalendarObject>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
apiCtCoolingSystemGetCalendarLogCountGet.PATH = '/api/CT/CoolingSystem/GetCalendarLogCount';
apiCtCoolingSystemGetCalendarLogCountGet.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
apiCtCoolingSystemGetCalendarLogCountGet.ROOTURL = '/cooling';
